function Home() {
    return (
        <div className="w-8/12 md:w-7/12 lg:w-6/12 xl:w-3/12 2xl:w-3/12 pb-6 sm:pb-12 md:pr-0 pr-5 2xl:text-lg text-sm text-justify contentpage self-end">
            Experienced across all phases of the development lifecycle, from system design to deployment, with expertise in both frontend and backend development for mobile and desktop platforms. I also think infra is really cool, so I'm working on homelabbing as well. 
            < br/>
            < br/>
            My favorite interface with the computer is the keyboard; I absolutely adore typing on the keyboard. That means cli as much as possible, window managers over desktop environments and vimium extensions in my browser. I have four keyboards.
            < br/>
            < br/>
            You can find most of my work on <a href="https://github.com/cthdarren/" target="_blank" rel="noreferrer"><u>Github.</u></a>
            <br />
            <br />
            Currently, I am:
            <ol className="list-disc list-outside ml-5">
                <li>
                    Software Engineer at Venti Technologies. Mainly focusing on infra and devops, with some backend development.
                </li>
                <li>
                    Technical stuff aside, I've recently been working on building up my people skills, being comfortable with meeting new people and overall trying to enjoy life. It's been going great so far.
                </li>
            </ol>
        </div>
    );
}

export default Home;
